import { Base } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/additionalServices/additionalServices.base";
import { Item } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/additionalServices/components/item";

export const AdditionalServices = Object.assign(Base, {
    Item: Item
});
